<div class="register-number-outer-container">
  <div class="device-caption" *ngIf="!isOnboardingFlow">
    {{device?.displayName}}
  </div>
  <div class="info-container">
    <div class="headings-container">
      <div class="heading">
        <adp-label labelKey="RegisterNumber_Heading"></adp-label>
      </div>
      <div class="subheading">
        <adp-label labelKey="RegisterNumber_Subheading"></adp-label>
      </div>
    </div>
    <div modal-body class="input-container">
      <form [formGroup]="phoneNumberForm" name="phoneNumberFormdGroup" class="enter-phonenumber-form">
        <div class="row">
          <adp-input class="w-100"
            [resourceData]="resourceService.getResourceObject('RegisterNumber_PhoneNumber_Field')"
            formControlName="mobileNumber"></adp-input>
        </div>
        <div class="row">
          <div><button class="register-phone-button" mat-flat-button color="accent"
              (click)="handleRegisterPhoneNumber()" [disabled]="!phoneNumberForm.valid"><adp-label
                labelKey="RegisterNumber_SendMessage_Button_Label"></adp-label></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
